import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Image from "next/image";

export const ImageWrapper = styled.div`
  position: relative;
  min-width: 200px;
  margin: 0px 20px 0px 0px;
  &:hover {
    .image-overlay {
      opacity: 1;
    }
    .tooltip-text {
      visibility: visible;
    }
  }
  @media (max-width: 425px) {
    min-width: 100px;
    margin: 0px 10px 0px 0px;
  }
`;

const StyledImage = styled(Image)`
  width: 100%;
  max-width: 100%;
  border-radius: 4px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  backface-visibility: hidden;
`;

const Overlay = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  transition: 0.1s ease;
  opacity: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(30, 41, 51, 0.45);
  backdrop-filter: blur(2px);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
  border-radius: 4px;
`;

const OverlayTextContainer = styled.div`
  font-size: 14px;
  font-family: "Lato";
  font-weight: bold;
  background: linear-gradient(45deg, #f67062, #fc5296);
  color: #fff;
  border-radius: 4px;
  width: 50%;
  padding: 10px 32px;
  opacity: 1;
  margin: auto 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TitleContainer = styled.div`
  p {
    font-size: 12px;
    color: #fff;
    margin: 0;
  }
  p:nth-child(2) {
    margin: 5px;
  }
`;

const TooltipText = styled.div`
  visibility: hidden;
  width: 100%;
  background-color: rgba(30, 41, 51, 0.45);
  backdrop-filter: blur(2px);
  color: #fff;
  text-align: center;
  border-radius: 0px 0px 6px 6px;
  padding: 5px 0;
  box-sizing: border-box;

  position: absolute;
  z-index: 1;
  top: 90%;
`;

const StarContainer = styled.div`
  min-width: 0 !important;
  min-height: 0 !important;
  img {
    width: 16px !important;
    height: 16px !important;
  }
`;

const shimmer = (w, h) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#efefef" offset="0%" />
      <stop stop-color="#fff" offset="50%" />
      <stop stop-color="#efefef" offset="100%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#efefef" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;

const toBase64 = (str) =>
  typeof window === "undefined"
    ? Buffer.from(str).toString("base64")
    : window.btoa(str);

const BASE_PATH = process.env.BASE_PATH;
function LazyImage({
  src,
  alt,
  width,
  height,
  layout,
  context,
  category,
  display_size,
  isPremium,
}) {
  return (
    <ImageWrapper>
      <StyledImage
        width={width}
        height={height}
        placeholder="blur"
        blurDataURL={`data:image/svg+xml;base64,${toBase64(
          shimmer(width, height)
        )}`}
        layout={layout}
        src={src}
        alt={alt}
      />
      {context !== "preview-modal" && (
        <>
          <Overlay className="image-overlay">
            <OverlayTextContainer className="text">
              Preview
            </OverlayTextContainer>
            {Math.round(width / height) < 3 && (
              <TitleContainer>
                <>
                  {category && <p>{category}</p>}
                  <p>{display_size}</p>
                </>
              </TitleContainer>
            )}
          </Overlay>
          {Math.round(width / height) >= 3 && context !== "home-page" && (
            <TooltipText className="tooltip-text">
              <TitleContainer>
                <>
                  {category && <p>{category}</p>}
                  <p>{display_size}</p>
                </>
              </TitleContainer>
            </TooltipText>
          )}
        </>
      )}
      {isPremium && (
        <StarContainer
          style={{ position: "absolute", top: "5px", right: "5px" }}
        >
          <img
            src={`${BASE_PATH}/images/icon-star.svg`}
            alt="star-icon"
            width="16px"
            height="16px"
          />
        </StarContainer>
      )}
    </ImageWrapper>
  );
}

LazyImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default React.memo(LazyImage);
